/* eslint-disable max-lines -- one endpoint table for the cars API domain; declarations only */
import type {
  CarCatalogEventsListApiData,
  CarCatalogEventsListApiResponses,
  CarCatalogFitmentCreateApiData,
  CarCatalogFitmentCreateApiResponses,
  CarCatalogRefreshApiData,
  CarCatalogRefreshApiResponses,
  CarDataFromLicensePlateNumberApiData,
  CarDataFromLicensePlateNumberApiResponses,
  CarFromLicensePlateNumberApiData,
  CarFromLicensePlateNumberApiResponses,
  CarGetApiData,
  CarGetApiResponses,
  CarListApiData,
  CarListApiResponses,
  CarMeasuredTireDimensionsApiData,
  CarMeasuredTireDimensionsApiResponses,
  CarOwnerEndApiData,
  CarOwnerEndApiResponses,
  CarOwnersGetApiData,
  CarOwnersGetApiResponses,
  CarPatchApiData,
  CarPatchApiResponses,
  CarRoleLinkCreateApiData,
  CarRoleLinkCreateApiResponses,
  CarsForLabelPrintApiData,
  CarsForLabelPrintApiResponses,
  CarTabCountsApiData,
  CarTabCountsApiResponses,
  CarTireOriginalEquipmentMarkCreateApiData,
  CarTireOriginalEquipmentMarkCreateApiResponses,
  CarTireOriginalEquipmentMarkDeleteApiData,
  CarTireOriginalEquipmentMarkDeleteApiResponses,
  CarTireOriginalEquipmentMarkGetApiData,
  CarTireOriginalEquipmentMarkGetApiResponses,
  CarTireOriginalEquipmentMarkListApiData,
  CarTireOriginalEquipmentMarkListApiResponses,
  CarTireOriginalEquipmentMarkUpdateApiData,
  CarTireOriginalEquipmentMarkUpdateApiResponses,
  CarTireTreadDepthLatestApiData,
  CarTireTreadDepthLatestApiResponses,
  CarUpdateDataApiData,
  CarUpdateDataApiResponses,
  CarWheelInspectionCreateApiData,
  CarWheelInspectionCreateApiResponses,
  CarWheelInspectionListApiData,
  CarWheelInspectionListApiResponses,
  CarWheelMeasurementListApiData,
  CarWheelMeasurementListApiResponses,
  CarWheelSetAxleTireEventCreateApiData,
  CarWheelSetAxleTireEventCreateApiResponses,
  CarWheelSetAxleTireEventListApiData,
  CarWheelSetAxleTireEventListApiResponses,
  CarWheelSetByTypeApiData,
  CarWheelSetByTypeApiResponses,
  CarWheelSetDeleteApiData,
  CarWheelSetDeleteApiResponses,
  CarWheelSetDimensionsGetApiData,
  CarWheelSetDimensionsGetApiResponses,
  CarWheelSetGetApiData,
  CarWheelSetGetApiResponses,
  CarWheelSetGetOrCreateByTypeApiData,
  CarWheelSetGetOrCreateByTypeApiResponses,
  CarWheelSetPatchApiData,
  CarWheelSetPatchApiResponses,
  CarWheelSetsByCarApiData,
  CarWheelSetsByCarApiResponses,
  CarWheelSetsForLabelPrintListApiData,
  CarWheelSetsForLabelPrintListApiResponses,
  CarWheelSetsPickupWorkersListApiData,
  CarWheelSetsPickupWorkersListApiResponses,
  CarWheelSetsToPickupListApiData,
  CarWheelSetsToPickupListApiResponses,
  CarWorkerOverviewApiData,
  CarWorkerOverviewApiResponses,
  CatalogCoverageApiData,
  CatalogCoverageApiResponses,
  CatalogFactOverrideBulkSetApiData,
  CatalogFactOverrideBulkSetApiResponses,
  CatalogMatchingRerunApiData,
  CatalogMatchingRerunApiResponses,
  CatalogMatchVolumeAssignApiData,
  CatalogMatchVolumeAssignApiResponses,
  CatalogMatchVolumeListApiData,
  CatalogMatchVolumeListApiResponses,
  CatalogMatchVolumeSummaryApiData,
  CatalogMatchVolumeSummaryApiResponses,
  CatalogNodeEventsListApiData,
  CatalogNodeEventsListApiResponses,
  CatalogWheelLockCreateApiData,
  CatalogWheelLockCreateApiResponses,
  CatalogWheelLockDeleteApiData,
  CatalogWheelLockDeleteApiResponses,
  CatalogWheelLockGetApiData,
  CatalogWheelLockGetApiResponses,
  CatalogWheelLockListApiData,
  CatalogWheelLockListApiResponses,
  CatalogWheelLockPatchApiData,
  CatalogWheelLockPatchApiResponses,
  CatalogWheelSizeRefreshApiData,
  CatalogWheelSizeRefreshApiResponses,
  LicensePlate,
  RegistryIdentityNameListApiData,
  RegistryIdentityNameListApiResponses,
  ServiceWorkerCarWheelInspectionListApiData,
  ServiceWorkerCarWheelInspectionListApiResponses,
  ServiceWorkerInspectionTaskStatsApiData,
  ServiceWorkerInspectionTaskStatsApiResponses,
  StuddedTireSeasonGetApiData,
  StuddedTireSeasonGetApiResponses,
  VehicleCatalogModificationListApiData,
  VehicleCatalogModificationListApiResponses,
  VehicleCatalogNodeCreateApiData,
  VehicleCatalogNodeCreateApiResponses,
  VehicleCatalogNodeFamilyAssignPatchApiData,
  VehicleCatalogNodeFamilyAssignPatchApiResponses,
  VehicleCatalogNodeFamilyImagePatchApiData,
  VehicleCatalogNodeFamilyImagePatchApiResponses,
  VehicleCatalogNodeFamilySuggestionListApiData,
  VehicleCatalogNodeFamilySuggestionListApiResponses,
  VehicleCatalogNodeGetApiData,
  VehicleCatalogNodeGetApiResponses,
  VehicleCatalogNodeListApiData,
  VehicleCatalogNodeListApiResponses,
  VehicleCatalogNodeLogoPatchApiData,
  VehicleCatalogNodeLogoPatchApiResponses,
  VehicleCatalogNodePatchApiData,
  VehicleCatalogNodePatchApiResponses
} from '@navio/nsdk';

import { convertObjectKeysToSnakeCase } from '../../keyConversion';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

type CarLicensePlateHistoryItem = {
  id: number;
  licensePlate: LicensePlate;
  licensePlateNumber: string;
  fromDate: string;
  toDate?: string | null;
};

type CarLicensePlatesRecord = {
  current?: Array<CarLicensePlateHistoryItem>;
  previous?: Array<CarLicensePlateHistoryItem>;
};

// An empty file is not a replacement. The clear flags remove a stored photo.
const appendCatalogWheelLockImage = (formData: FormData, key: string, image: Blob | File | null | undefined) => {
  if (image instanceof Blob && image.size > 0) {
    formData.append(key, image);
  }
};

const catalogWheelLockFormData = (
  text: Record<string, string | undefined>,
  images: { patternImage?: Blob | File | null; fastenerImage?: Blob | File | null },
  clears?: { clearPatternImage?: boolean; clearFastenerImage?: boolean }
) => {
  const formData = new FormData();
  const definedText: Record<string, string> = {};
  for (const [key, value] of Object.entries(text)) {
    if (typeof value === 'string') {
      definedText[key] = value;
    }
  }
  const snakeText = convertObjectKeysToSnakeCase(definedText);
  for (const [key, value] of Object.entries(snakeText)) {
    if (typeof value === 'string') {
      formData.append(key, value);
    }
  }
  appendCatalogWheelLockImage(formData, 'pattern_image', images.patternImage);
  appendCatalogWheelLockImage(formData, 'fastener_image', images.fastenerImage);
  if (clears?.clearPatternImage) {
    formData.append('clear_pattern_image', 'true');
  }
  if (clears?.clearFastenerImage) {
    formData.append('clear_fastener_image', 'true');
  }
  return formData;
};

// Cars

export const getCarUrls = {
  getVehicleCatalogModifications: dataEndpoint<
    VehicleCatalogModificationListApiData,
    VehicleCatalogModificationListApiResponses
  >({
    getUrl: ({ nodeId, ...query }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/modifications/`, query)
  }),
  getVehicleCatalogNodes: dataEndpoint<VehicleCatalogNodeListApiData, VehicleCatalogNodeListApiResponses>({
    getUrl: (queryParams) => apiUrl('vehicle-catalog-nodes/', queryParams)
  }),
  getVehicleCatalogNode: dataEndpoint<VehicleCatalogNodeGetApiData, VehicleCatalogNodeGetApiResponses>({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/`)
  }),
  getPaginatedCatalogNodeEvents: dataEndpoint<CatalogNodeEventsListApiData, CatalogNodeEventsListApiResponses>({
    getUrl: ({ nodeId, ...queryParams }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/events/`, queryParams)
  }),
  postVehicleCatalogNode: responseEndpoint<VehicleCatalogNodeCreateApiData, VehicleCatalogNodeCreateApiResponses>({
    getUrl: () => apiUrl('vehicle-catalog-nodes/'),
    getBody: (data) => data
  }),
  patchVehicleCatalogNode: responseEndpoint<VehicleCatalogNodePatchApiData, VehicleCatalogNodePatchApiResponses>({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/`),
    getBody: ({ nodeId: _, ...body }) => body
  }),
  patchVehicleCatalogNodeLogo: responseEndpoint<
    VehicleCatalogNodeLogoPatchApiData,
    VehicleCatalogNodeLogoPatchApiResponses,
    { nodeId: number; logo: File | null }
  >({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/logo/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ logo }) => {
      const formData = new FormData();
      // An empty part is how a multipart patch clears the file.
      formData.append('logo', logo ?? '');
      return formData;
    },
    skipBodyTransformation: true
  }),
  patchVehicleCatalogNodeFamilyImage: responseEndpoint<
    VehicleCatalogNodeFamilyImagePatchApiData,
    VehicleCatalogNodeFamilyImagePatchApiResponses,
    { nodeId: number; image: File | null }
  >({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/family-image/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ image }) => {
      const formData = new FormData();
      // An empty part is how a multipart patch clears the file.
      formData.append('image', image ?? '');
      return formData;
    },
    skipBodyTransformation: true
  }),
  getVehicleCatalogNodeFamilySuggestions: dataEndpoint<
    VehicleCatalogNodeFamilySuggestionListApiData,
    VehicleCatalogNodeFamilySuggestionListApiResponses
  >({
    getUrl: ({ nodeId, ...query }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/family-suggestions/`, query)
  }),
  patchVehicleCatalogNodeFamily: responseEndpoint<
    VehicleCatalogNodeFamilyAssignPatchApiData,
    VehicleCatalogNodeFamilyAssignPatchApiResponses
  >({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/family/`),
    getBody: ({ nodeId: _, ...body }) => body
  }),
  postCatalogFactOverrides: responseEndpoint<CatalogFactOverrideBulkSetApiData, CatalogFactOverrideBulkSetApiResponses>(
    {
      getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/fact-overrides/bulk/`),
      getBody: ({ nodeId: _, ...body }) => body
    }
  ),
  postCarCatalogRefresh: responseEndpoint<CarCatalogRefreshApiData, CarCatalogRefreshApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/catalog-refresh/`),
    getBody: () => ({})
  }),
  postCatalogWheelSizeRefresh: responseEndpoint<CatalogWheelSizeRefreshApiData, CatalogWheelSizeRefreshApiResponses>({
    getUrl: ({ nodeId }) => apiUrl(`vehicle-catalog-nodes/${nodeId}/wheel-size-refresh/`),
    getBody: ({ nodeId: _, ...body }) => body
  }),
  getRegistryIdentityNames: dataEndpoint<RegistryIdentityNameListApiData, RegistryIdentityNameListApiResponses>({
    getUrl: (queryParams) => apiUrl('cars/identity-names/', queryParams)
  }),
  postCarCatalogFitment: responseEndpoint<CarCatalogFitmentCreateApiData, CarCatalogFitmentCreateApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/catalog-fitments/`),
    getBody: ({ carId: _, ...body }) => body
  }),

  getStuddedTireSeason: dataEndpoint<StuddedTireSeasonGetApiData, StuddedTireSeasonGetApiResponses>({
    getUrl: (queryParams) => apiUrl('studded-tire-season/', queryParams)
  }),
  getPaginatedPrintingLabels: dataEndpoint<
    CarWheelSetsForLabelPrintListApiData,
    CarWheelSetsForLabelPrintListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-wheel-sets/for-label-printing/', queryParams)
  }),
  getCarsForLabelPrinting: dataEndpoint<CarsForLabelPrintApiData, CarsForLabelPrintApiResponses>({
    getUrl: (queryParams) => apiUrl('cars/for-label-printing/', queryParams)
  }),
  getCarWorkerOverview: dataEndpoint<CarWorkerOverviewApiData, CarWorkerOverviewApiResponses>({
    getUrl: (queryParams) => apiUrl('cars/worker-overview/', queryParams)
  }),
  getPaginatedCars: dataEndpoint<CarListApiData, CarListApiResponses>({
    getUrl: (queryParams) => apiUrl('cars/', queryParams)
  }),
  getCatalogCoverage: dataEndpoint<CatalogCoverageApiData, CatalogCoverageApiResponses>({
    getUrl: () => apiUrl('catalog/coverage/')
  }),
  getCatalogMatchVolume: dataEndpoint<CatalogMatchVolumeListApiData, CatalogMatchVolumeListApiResponses>({
    getUrl: (queryParams) => apiUrl('catalog/match-volume/', queryParams)
  }),
  getCatalogMatchVolumeSummary: dataEndpoint<CatalogMatchVolumeSummaryApiData, CatalogMatchVolumeSummaryApiResponses>({
    getUrl: (queryParams) => apiUrl('catalog/match-volume/summary/', queryParams)
  }),
  postCatalogMatchVolumeAssignments: responseEndpoint<
    CatalogMatchVolumeAssignApiData,
    CatalogMatchVolumeAssignApiResponses
  >({
    getUrl: () => apiUrl('catalog/match-volume/assignments/'),
    getBody: (data) => data
  }),
  postCatalogMatchingRerun: dataEndpoint<CatalogMatchingRerunApiData, CatalogMatchingRerunApiResponses>({
    getUrl: () => apiUrl('catalog/coverage/')
  }),
  patchCarDetails: responseEndpoint<CarPatchApiData, CarPatchApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/`),
    getBody: ({ carId: _, ...body }) => body
  }),
  getCarWheelSet: dataEndpoint<CarWheelSetGetApiData, CarWheelSetGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`car-wheel-sets/${pk}/`)
  }),
  patchCarWheelSet: responseEndpoint<CarWheelSetPatchApiData, CarWheelSetPatchApiResponses>({
    getUrl: ({ pk }) => apiUrl(`car-wheel-sets/${pk}/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  deleteCarWheelSet: dataEndpoint<CarWheelSetDeleteApiData, CarWheelSetDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`car-wheel-sets/${pk}/`)
  }),
  getCarWheelSetsForCar: dataEndpoint<CarWheelSetsByCarApiData, CarWheelSetsByCarApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/wheel-sets/`)
  }),
  getCarWheelSetAxleTireEvents: dataEndpoint<
    CarWheelSetAxleTireEventListApiData,
    CarWheelSetAxleTireEventListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-wheel-set-axle-tire-events/', queryParams)
  }),
  postCarWheelSetAxleTireEvent: responseEndpoint<
    CarWheelSetAxleTireEventCreateApiData,
    CarWheelSetAxleTireEventCreateApiResponses
  >({
    getUrl: () => apiUrl('car-wheel-set-axle-tire-events/'),
    getBody: (data) => data
  }),
  getCarWheelSetForCar: dataEndpoint<CarWheelSetByTypeApiData, CarWheelSetByTypeApiResponses>({
    getUrl: ({ carId, ...queryParams }) => apiUrl(`cars/${carId}/wheel-set/`, queryParams)
  }),
  postCarWheelSetGetOrCreate: responseEndpoint<
    CarWheelSetGetOrCreateByTypeApiData,
    CarWheelSetGetOrCreateByTypeApiResponses
  >({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/wheel-set/`),
    getBody: ({ carId: _, ...body }) => body
  }),
  getCar: dataEndpoint<CarGetApiData, CarGetApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/`)
  }),
  getPaginatedCarCatalogEvents: dataEndpoint<CarCatalogEventsListApiData, CarCatalogEventsListApiResponses>({
    getUrl: ({ carId, ...queryParams }) => apiUrl(`cars/${carId}/catalog-events/`, queryParams)
  }),
  getCarOwners: dataEndpoint<CarOwnersGetApiData, CarOwnersGetApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/owners/`)
  }),
  getCarTabCounts: dataEndpoint<CarTabCountsApiData, CarTabCountsApiResponses>({
    getUrl: ({ carId, ...queryParams }) => apiUrl(`cars/${carId}/tab-counts/`, queryParams)
  }),
  // Extra until nsdk is re-synced after BE license-plates history endpoint.
  getCarLicensePlates: dataEndpoint<CarGetApiData, { 200: CarLicensePlatesRecord }>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/license-plates/`)
  }),
  endCarOwner: responseEndpoint<CarOwnerEndApiData, CarOwnerEndApiResponses>({
    getUrl: ({ carId, userGroupCarId }) => apiUrl(`cars/${carId}/owners/${userGroupCarId}/end/`),
    getBody: ({ carId: _carId, userGroupCarId: _userGroupCarId, ...body }) => body
  }),
  createCarRoleLink: responseEndpoint<CarRoleLinkCreateApiData, CarRoleLinkCreateApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/role-links/`),
    getBody: ({ carId: _carId, ...body }) => body
  }),
  postCarUpdateData: responseEndpoint<CarUpdateDataApiData, CarUpdateDataApiResponses>({
    getUrl: () => apiUrl('cars/update-data/'),
    getBody: (data) => data
  }),
  getDataFromLicensePlateNumber: dataEndpoint<
    CarDataFromLicensePlateNumberApiData,
    CarDataFromLicensePlateNumberApiResponses
  >({
    getUrl: (queryParams) => apiUrl('cars/data-from-license-plate-number/', queryParams)
  }),
  getCarFromLicensePlateNumber: dataEndpoint<CarFromLicensePlateNumberApiData, CarFromLicensePlateNumberApiResponses>({
    getUrl: (queryParams) => apiUrl('cars/from-license-plate-number/', queryParams)
  }),
  getPaginatedCatalogWheelLocks: dataEndpoint<CatalogWheelLockListApiData, CatalogWheelLockListApiResponses>({
    getUrl: (queryParams) => apiUrl('catalog-wheel-locks/', queryParams)
  }),
  getCatalogWheelLock: dataEndpoint<CatalogWheelLockGetApiData, CatalogWheelLockGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`catalog-wheel-locks/${pk}/`)
  }),
  postCatalogWheelLock: responseEndpoint<CatalogWheelLockCreateApiData, CatalogWheelLockCreateApiResponses>({
    getUrl: () => apiUrl('catalog-wheel-locks/'),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ patternImage, fastenerImage, ...text }) =>
      catalogWheelLockFormData(text, { patternImage, fastenerImage }),
    skipBodyTransformation: true
  }),
  patchCatalogWheelLock: responseEndpoint<CatalogWheelLockPatchApiData, CatalogWheelLockPatchApiResponses>({
    getUrl: ({ pk }) => apiUrl(`catalog-wheel-locks/${pk}/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({
      patternImage,
      fastenerImage,
      clearPatternImage,
      clearFastenerImage,
      name,
      slug,
      manufacturer,
      fastenerForm,
      drivePattern,
      collar,
      cap,
      sourceUrl,
      summary
    }) =>
      catalogWheelLockFormData(
        { name, slug, manufacturer, fastenerForm, drivePattern, collar, cap, sourceUrl, summary },
        { patternImage, fastenerImage },
        { clearPatternImage, clearFastenerImage }
      ),
    skipBodyTransformation: true
  }),
  deleteCatalogWheelLock: dataEndpoint<CatalogWheelLockDeleteApiData, CatalogWheelLockDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`catalog-wheel-locks/${pk}/`)
  }),
  getPaginatedCarTireOEMarks: dataEndpoint<
    CarTireOriginalEquipmentMarkListApiData,
    CarTireOriginalEquipmentMarkListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-tire-original-equipment-marks/', queryParams)
  }),
  getCarTireOEMark: dataEndpoint<CarTireOriginalEquipmentMarkGetApiData, CarTireOriginalEquipmentMarkGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`car-tire-original-equipment-marks/${pk}/`)
  }),
  postCarTireOEMarks: responseEndpoint<
    CarTireOriginalEquipmentMarkCreateApiData,
    CarTireOriginalEquipmentMarkCreateApiResponses
  >({
    getUrl: () => apiUrl('car-tire-original-equipment-marks/'),
    getBody: (data) => data
  }),
  patchCarTireOEMarks: responseEndpoint<
    CarTireOriginalEquipmentMarkUpdateApiData,
    CarTireOriginalEquipmentMarkUpdateApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`car-tire-original-equipment-marks/${pk}/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  deleteCarTireOEMarks: dataEndpoint<
    CarTireOriginalEquipmentMarkDeleteApiData,
    CarTireOriginalEquipmentMarkDeleteApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`car-tire-original-equipment-marks/${pk}/`)
  }),
  getCarWheelSetsToPickUp: dataEndpoint<CarWheelSetsToPickupListApiData, CarWheelSetsToPickupListApiResponses>({
    getUrl: (queryParams) => apiUrl('car-wheel-sets/to-pickup/', queryParams)
  }),
  getWheelSetPickupWorkers: dataEndpoint<
    CarWheelSetsPickupWorkersListApiData,
    CarWheelSetsPickupWorkersListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-wheel-sets/pickup-workers/', queryParams)
  }),
  getLatestCarWheelMeasurements: dataEndpoint<CarTireTreadDepthLatestApiData, CarTireTreadDepthLatestApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/tire-tread-depth-latest/`)
  }),
  postCarWheelInspectionWeb: responseEndpoint<CarWheelInspectionCreateApiData, CarWheelInspectionCreateApiResponses>({
    getUrl: () => apiUrl('car-wheel-inspections/'),
    getBody: ({ image, ...data }) => {
      const formData = new FormData();
      if (image) {
        formData.append('image', image);
      }
      Object.entries(convertObjectKeysToSnakeCase(data)).forEach(([key, value]) => {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          formData.append(key, String(value));
        }
      });
      return formData;
    },
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    skipBodyTransformation: true
  }),
  getCarWheelDimensions: dataEndpoint<CarWheelSetDimensionsGetApiData, CarWheelSetDimensionsGetApiResponses>({
    getUrl: (queryParams) => apiUrl('car-wheel-set-dimensions/', queryParams)
  }),
  getBookingCarInspections: dataEndpoint<CarWheelInspectionListApiData, CarWheelInspectionListApiResponses>({
    getUrl: (queryParams) => apiUrl('car-wheel-inspections/for-booking/', queryParams)
  }),
  getPaginatedServiceWorkerCarWheelInspections: dataEndpoint<
    ServiceWorkerCarWheelInspectionListApiData,
    ServiceWorkerCarWheelInspectionListApiResponses
  >({
    getUrl: ({ serviceWorkerId, ...rest }) => apiUrl(`service-workers/${serviceWorkerId}/car-wheel-inspections/`, rest)
  }),
  getServiceWorkerInspectionTaskStats: dataEndpoint<
    ServiceWorkerInspectionTaskStatsApiData,
    ServiceWorkerInspectionTaskStatsApiResponses
  >({
    getUrl: ({ serviceWorkerId, ...rest }) => apiUrl(`service-workers/${serviceWorkerId}/inspection-task-stats/`, rest)
  }),
  // Extra wheelPositions until nsdk is re-synced after BE filter addition.
  getPaginatedCarWheelMeasurements: dataEndpoint<
    {
      body?: never;
      path?: never;
      query?: NonNullable<CarWheelMeasurementListApiData['query']> & {
        wheelPositions?: Array<number>;
      };
    },
    CarWheelMeasurementListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-wheel-measurements/', queryParams)
  }),
  getCarMeasuredTireDimensions: dataEndpoint<CarMeasuredTireDimensionsApiData, CarMeasuredTireDimensionsApiResponses>({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/measured-tire-dimensions/`)
  })
};
